@if (multimedia(); as multimedia) {
  <div class="flex flex-col">
    @if (shouldShowAttribute('id')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Identyfikator pliku:
        </div>
        <div>{{ multimedia.id }}</div>
      </div>
    }

    @if (shouldShowAttribute('filenameWithExtension')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Nazwa pliku:
        </div>
        <div>{{ multimedia.filename }}.{{ multimedia.extension }}</div>
      </div>
    }

    @if (shouldShowAttribute('mimeType')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Typ pliku:
        </div>
        <div>{{ multimedia.mimeType }}</div>
      </div>
    }

    @if (shouldShowAttribute('size')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Rozmiar pliku:
        </div>
        <div>{{ multimedia.size | filesize }}</div>
      </div>
    }

    @if (shouldShowAttribute('dimensions')) {
      @if (shouldShowDimensions(multimedia)) {
        <div class="mb-3">
          <div
            appLabelStyle
            class="mb-0">
            Wymiary:
          </div>
          <div>{{ multimedia.dimensions }} pikseli</div>
        </div>
      }
    }

    @if (shouldShowAttribute('createdAt')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Data utworzenia:
        </div>
        <div>{{ multimedia.createdAt | dateFormat }}</div>
      </div>
    }

    @if (shouldShowAttribute('filename')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Tytuł:
        </div>
        <div>{{ multimedia.filename | noData }}</div>
      </div>
    }

    @if (shouldShowAttribute('alt')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Tekst alternatywny:
        </div>
        <div>{{ multimedia.alt | noData }}</div>
      </div>
    }

    @if (shouldShowAttribute('description')) {
      <div class="mb-3">
        <div
          appLabelStyle
          class="mb-0">
          Opis:
        </div>
        <div>{{ multimedia.description | noData }}</div>
      </div>
    }
  </div>
}
